import React from 'react';
import { ListItem, Text } from '@rneui/themed';
import { useTagItemCreateMutation, useTagItemDeleteMutation, } from '@annunciate/query';
import { FAIcon } from '../elements';
export const TagListItem = ({ item, tag, }) => {
    const { mutateAsync: create } = useTagItemCreateMutation();
    const { mutateAsync: remove } = useTagItemDeleteMutation();
    const tagItem = tag.items.find(({ entityId, entityType }) => {
        return entityId === item.id &&
            entityType === item.__typename;
    });
    const createOrRemoveTag = async () => {
        if (tagItem) {
            await remove({ id: tagItem.id });
        }
        else {
            await create({
                item: {
                    parentId: tag.id,
                    entityId: item.id,
                    entityType: item.__typename,
                },
            });
        }
    };
    return (React.createElement(ListItem, { onPress: createOrRemoveTag },
        React.createElement(ListItem.Content, null,
            React.createElement(ListItem.Title, null,
                React.createElement(Text, { bold: false }, tag.name))),
        tagItem && (React.createElement(FAIcon, { name: 'check' }))));
};
//# sourceMappingURL=TagListItem.js.map